import _ from 'lodash'
// 组件方法
const componentMixin = {
  mounted () {
    this.$emit('create', this)
  },
  destroyed () {
    this.$emit('destory', this)
  }
}

const dataSourceMixin = {
  methods: {
    loadTemplateOptions () {
      this.options = []
      this.initComponent.properties.template.stringOptions.trim().split('\n').forEach(m => {
        this.options.push({id: m, value: m})
      })
    },
    loadDataSourceOptions () {
      this.options = []
      let dataSource = this.initComponent.properties.dataSource
      let params = {'index': -1, 'size': -1}
      let columnId = dataSource.columnId
      let showColumnId = dataSource.showColumnId
      params.filters = dataSource.filter
      dataSource.filter && Object.keys(dataSource.filter).forEach(m => {
        if (!dataSource.filter[m].match(/\$\{(.*?)\}/)) {
          params.filters[m] = dataSource.filter[m]
        }
      })
      this.$axios.get(`/report-api/report/data/${dataSource.reportId}`, {params: params}).then((res) => {
        let options = []
        res.data.forEach(m => {
          options.push({id: m[columnId], value: m[showColumnId]})
        })
        this.options = options
      })
    }
  }
}
// 计算表达式方法
const calculateMixin = {
  methods: {
    expressionToWithCode (expression) {
      expression = this.handleSqlExpression(expression)
      expression.match(/\$\{(.+?)\}/g) && expression.match(/\$\{(.+?)\}/g).map((el) => {
        let dataId = el.replace(/[${}]/g, '').split(',')[0].split('+')[0]
        let relationId = el.replace(/[${}]/g, '').split(',')[0].split('+')[1]
        let codeAttr = this.find(this.getDataSource, dataId, relationId)
        let code = `&nbsp;<code contenteditable='false' dataId=${codeAttr.column.id}+${codeAttr.relationId} name=${codeAttr.column.name} type='${codeAttr.column.dataType}' title="${codeAttr.tableName}-${codeAttr.column.name}">${codeAttr.column.name}</code>&nbsp;`
        expression = expression.replace(el, code)
      })
      return expression
    },
    // 处理辅助表表达式
    handleSqlExpression (expression) {
      if (expression.match(/sql\((.+?)(}|])\)/g)) {
        expression.match(/parameter\[(.+?)\]/g) && expression.match(/parameter\[(.+?)\]/g).map(m => {
          expression = expression.replace(',' + m, '')
        })
        expression.match(/sql\((.+?)(}|])\)/g) && expression.match(/sql\((.+?)(}|])\)/g).map(m => {
          // 表名 + 数据字段名
          let name = m.match(/\$\{(.*?)\}/)[1] && m.match(/\$\{(.*?)\}/)[1].split(',')[1]
          // 数据字段名
          let dataSourceName = name && name.split('-') && name.split('-')[name.split('-').length - 1]
          let code = `&nbsp;<code contenteditable='false' type='sql' title="${name}">sql(${dataSourceName})</code>&nbsp;`
          expression = expression.replace(m, code)
        })
      }
      return expression
    },

    // 加载公式的时候dataId去数据列中遍历右侧的数据列找到对应列的name,id,tyle,和表名
    find (tables, id, relationId) {
      let column = {}
      let table
      if (relationId === 'undefined') {
        table = tables.find(m => {
          column = m.columns.find(n => n.id === id)
          if (column) {
            relationId = m.relationId
            return m
          }
        })
      } else {
        table = tables.find(m => m.relationId === relationId)
        column = table.columns && table.columns.find(m => m.id === id)
      }
      let result = {'column': {}, 'tableName': '', relationId}
      if (column && table) {
        result = {column, 'tableName': table.name, relationId}
      }
      return result
    }
  },
  computed: {
    getDataSource () {
      let parent = this.formService.getParentComponent(this.component)
      let archive = this.formService.getParentArchived(parent)
      let tables = this.formService.schema.getRelationTable(archive.relationId, this.component.archive.tableId)
      tables.oneToManyTables.forEach(m => {
        m.type = 'OneToMany'
      })
      tables.oneToOneTables.forEach(m => {
        m.type = 'OneToOne'
      })
      return _.concat(tables.oneToOneTables, tables.oneToManyTables)
    }
  }
}

export { componentMixin, calculateMixin, dataSourceMixin }



// WEBPACK FOOTER //
// ./src/components/form/components/mixins.js